import { UnidadMedidaDto, TipoMaterialDto } from '../../../../src/app/shared/model';

export class MaterialDto {
  constructor(
    public Id: number | null,
    public Nombre: string | null,
    public UnidadMedidaMaterialId: number | null,
    public UnidadMedidaMaterialNombre: string | null,
    public TipoMaterialId: number | null,
    public TipoMaterialNombre: string | null,
    public PresupuestoUrl: string | null,
    public Activo: boolean
  ) { }
}

export class SaveMaterialDto {
  constructor(
    public readonly Nombre: string | null,
    public readonly TipoMaterialId: number | null,
    public readonly UnidadMedidaMaterialId: number | null,
    public readonly Activo: boolean
  ) { }
}

export class SearchMaterialRequest {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public readonly Nombre: string | null,
    public readonly Codigo: string | null,
    public readonly TipoMaterialId: number | null,
    public readonly VerSoloActivos: boolean
  ) { }
}

export class SearchMaterialResponse {
  constructor(
    public readonly count: number,
    public readonly result: MaterialDto[]
  ) { }
}
